import {
  FETCH_LOAD_PROJECT_REQUEST,
  FETCH_LOAD_PROJECT_SUCCESS,
  FETCH_LOAD_PROJECT_FALUIRE,
} from './loadAllProjectsTypes'

const initialState = {
  loading: false,
  allProjectList: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LOAD_PROJECT_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LOAD_PROJECT_SUCCESS : return {
      ...state,
      allProjectList: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LOAD_PROJECT_FALUIRE : return {
      ...state,
      loading: false,
      allProjectList: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
